import React, {PureComponent} from "react";
import $ from "jquery";
import {Modal} from "react-responsive-modal";

import {Trans, withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import MarshallWarningComponent from "../independentComponents/marshallWarningComponent";

import Moment from "moment-timezone";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class LoggingBox extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            eventRows: [],
            myTable: "#logging",
            myTableBody: "#logging tbody",
            myTableRows: "#logging tbody tr",
            myTableColumn: "#logging th",
            pageSize: 0,
            firstRecord: 0,
            show: false,
            showTable: false,
            sessionDetails: {
                circuit: "---",
                circuit_id: -1,
                event_id: -1,
                length: 0,
                length_delimiter: "time",
                map_center_lat: 0,
                map_center_lng: 0,
                map_center_zoom_level: 0,
                map_rotation: 0,
                order_factor: "bestlap",
                session: "---",
                start_timestamp: 0,
                scheduled_start_timestamp: 0,
                timezone: "---",
                track_length: 0,
            },
        };

        this.getMessageLog = this.getMessageLog.bind(this);
        this.buildRows = this.buildRows.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.initTable = this.initTable.bind(this);
        this.paginate = this.paginate.bind(this);
        this.handleClickPager = this.handleClickPager.bind(this);
        this.popoutFlagTelemetry = this.popoutFlagTelemetry.bind(this);
    }

    componentDidMount() {
        if (this.props.isSessionChoice) {
            this.setState({
                sessionDetails: this.props.sessionDetails,
            });
        }
    }

    /* PAGINATE TABLE */
    initTable() {
        $("#previous").hide();
        $("#next").show();
        this.setState({
            pageSize: 10,
            firstRecord: 0
        });
        // Start the pagination
        this.setState({
            showTable: true,
        }, () => {
            this.paginate(this.state.firstRecord, this.state.pageSize);
        });
    }

    paginate(start, size) {
        let tableRows = $(this.state.myTableRows);
        let end = start + size;
        // Hide all the rows
        tableRows.hide();
        // Show a reduced set of rows using a range of indices.
        tableRows.slice(start, end).show();
        // Show the pager
        $(".paginate").show();
        // If the first row is visible hide prev
        if (tableRows.eq(0).is(":visible")) {
            $("#previous").prop("disabled", true);
        } else {
            $("#previous").prop("disabled", false);
        }
        // If the last row is visible hide next
        if (tableRows.eq(tableRows.length - 1).is(":visible")) {
            $("#next").prop("disabled", true);
        } else {
            $("#next").prop("disabled", false);
        }
    }

    handleClickPager(e) {
        e.preventDefault();
        let tableRows = $(this.state.myTableRows);
        let tmpRec = this.state.firstRecord;
        let pageSize = this.state.pageSize;

        // Define the new first record
        if (e.target.id === "next") {
            tmpRec += pageSize;
        } else {
            tmpRec -= pageSize;
        }

        // The first record is < of 0 or > of total rows
        if (tmpRec < 0 || tmpRec > tableRows.length) {
            return;
        }

        // Update the current record
        this.setState({
            firstRecord: tmpRec,
        }, () => {
            this.paginate(tmpRec, pageSize);
        });
    }

    /* POPOUT */
    popoutFlagTelemetry(e) {
        e.preventDefault();
        let parts = e.currentTarget.value.split("_");
        window.open(
            "/flagIssueDetails/" +
            this.state.sessionDetails.event_id + "/" +
            this.props.sessionID + "/" +
            parts[0] + "/" +
            parts[1] + "/" +
            parts[2] + "/" +
            this.props.userID + "/" +
            this.state.sessionDetails.map_center_lat + "/" +
            this.state.sessionDetails.map_center_lng + "/" +
            this.state.sessionDetails.map_center_zoom_level + "/" +
            this.state.sessionDetails.map_rotation + "/" +
            parts[3] + "/" +
            null,
            "flagIssueDetails",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=20,top=100,width=800,height=850",
        );
    }

    /* HANDLERS */
    handleShowModal() {
        this.setState({
            show: true,
        }, () => {
            this.getMessageLog();
        });
    }

    handleClose() {
        this.setState({
            show: false,
            eventRows: []
        });
    }

    /* GET DATA */
    getMessageLog() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getEventLog",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                carID: helper.props.carID,
                sessionID: helper.props.sessionID,
                isOwnTeam: helper.props.isOwnTeam,
            },
            success: function (data) {
                helper.setState({
                    circuitTimezone: data[0],
                }, () => {
                    helper.buildRows(data[1]);
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                return false;
            }
        });
    }

    /* RENDER */
    buildRows(events) {
        let rows;
        if (events && events.length > 0) {
            rows = [];
            for (let i = 0; i < events.length; i++) {
                let message = <td/>;
                switch (events[i].log_entry_type) {
                    // GARAGE_MESSAGE_TO_CAR
                    case(1): {
                        rows.push(
                            <tr key={"log1_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className={"fas fa-envelope"}/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                <td style={{wordBreak: "break-all"}}>
                                    <Trans i18nKey={"teamMessageTo"}><strong>{this.props.t("teamMessageTo")}</strong></Trans> <b>{events[i].driver_name}</b>: " <b><i>{events[i].message}</i></b> "
                                </td>
                            </tr>
                        );
                        break;
                    }
                    // ORG_MESSAGE_TO_CAR
                    case(2): {
                        rows.push(
                            <tr key={"log2_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className="far fa-envelope"/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                <td data-i18n={"[html]content.body"} style={{wordBreak: "break-all"}}>
                                    <Trans i18nKey={"orgMessageTo"}><strong>{this.props.t("orgMessageTo")}</strong></Trans> <b>{events[i].driver_name}</b>: " <b><i>{events[i].message}</i></b> "
                                </td>
                            </tr>
                        );
                        break;
                    }
                    // INSTRUCTION_FLAG_DISPLAY_LOG
                    case(3): {
                        if (events[i].flag_type_id === 0) {
                            message = <td><b>{this.props.t("instructionCleared")}</b> {this.props.t("fromVehicle")} <b>#{events[i].livery_number}</b>!</td>;
                        } else {
                            let flagObj = this.props.convertFlags([events[i].flag_type_id,])[0];
                            message = (
                                <td>
                                    <img
                                        style={{marginTop: 0, width: 0}}
                                        className={"organizerPanel_flagStyle flag_logbox w3-animate-fading"}
                                        src={(serverIP + ":" + backendPort + "/images/flags/" + flagObj.src)}
                                        alt={"flag"}
                                    />
                                    <b>{events[i]["desc_" + this.props.cookies.get("lang")].toUpperCase()}</b> {this.props.t("issuedToVehicle")} <b>#{events[i].livery_number}</b>!
                                </td>
                            );
                        }
                        rows.push(
                            <tr key={"log3_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className="fas fa-exclamation"/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                {message}
                            </tr>
                        );
                        break;
                    }
                    // SESSION_FLAG_DISPLAY_LOG
                    case(4): {
                        let parsed = JSON.parse(events[i].flag_type_by_sectors);
                        let flagIDSum = parsed.reduce((a, b) => {
                            return a + b;
                        });
                        if (flagIDSum > 0) {
                            let sessionArray = this.props.convertFlags(parsed);
                            let temp = (
                                <MarshallWarningComponent
                                    marshallPosts={this.props.marshallPosts}
                                    sendFlag={null}
                                    fullCourseFlags={null}
                                    sessionStatus={sessionArray}
                                    isSingleVehicle={true}
                                    enableClick={false}
                                    isFlagPanel={false}
                                    hasTooltip={false}
                                />
                            );
                            //message = <td>{this.props.t("sessionState")} <b>{this.props.t("issued").toLowerCase()}</b>: {temp}</td>;
                            message = <td>{temp}</td>;

                        } else {
                            message = <td><Trans i18nKey={"sessionStateCleared"}><strong>{this.props.t("sessionStateCleared")}</strong></Trans>!</td>;
                        }

                        rows.push(
                            <tr key={"log4_" + i} className={"App_black_text"} style={{height: "8vh"}}>
                                <td className={"text-center"}><i className="fab fa-font-awesome-flag"/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                {message}
                                {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) && this.props.isSessionChoice && flagIDSum > 0 ? (
                                    <td className={"text-center"}>
                                        <button
                                            value={this.props.carID + "_" + events[i].timestamp + "_" + events[i].flag_clear_date + "_" + events[i].id}
                                            style={{background: "#ff0003", fontWeight: "bold"}}
                                            type={"button"}
                                            className={"btn printWhite button"}
                                            onClick={this.popoutFlagTelemetry}
                                        >
                                            <i className="fas fa-search" style={{color: "#FFFFFF"}}/>
                                        </button>
                                    </td>
                                ) : null}
                            </tr>
                        );
                        break;
                    }
                    // SESSION_ORG_CONTROL_OPS
                    case(5): {
                        let flag = true;

                        // Check if this message was directed at a specific vehicle
                        if (!isNaN(parseInt(events[i].op_obs))) {
                            if (this.props.carID !== parseInt(events[i].op_obs)) {
                                flag = false;
                                break;
                            }
                        }

                        if (flag) {
                            let op_final = "";
                            let parts = events[i].op_type.split("-");
                            for (let p = 0; p < parts.length; p++) {
                                op_final += parts[p].charAt(0).toUpperCase() + parts[p].substr(1, (parts[p].length - 1));
                                op_final += " ";
                            }

                            rows.push(
                                <tr key={"log5_" + i} className={"App_black_text"}>
                                    <td className={"text-center"}><i className="fas fa-exclamation-circle"/></td>
                                    <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                    <td><b>{op_final}</b> {this.props.t("commandIssuedBy")} <b>{events[i].org_username}</b>.</td>
                                </tr>
                            );
                        }
                        break;
                    }
                    // SESSION_DRIVER_CHANGE
                    case(6): {
                        let message = <td/>;
                        if (events[i].previous_driver_id) {
                            message = <td>{this.props.t("driverExchange")}: <b>{events[i].previous_driver}</b> {this.props.t("exitEnter")} <b>{events[i].current_driver}.</b></td>;
                        } else {
                            message = <td><b>{events[i].current_driver}</b> {this.props.t("enteredTrack")}.</td>;
                        }
                        rows.push(
                            <tr key={"log6_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className={"fas fa-exchange-alt"}/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                {message}
                            </tr>
                        );
                        break;
                    }
                    // DRIVER_REPLIES_TO_GARAGE
                    case(7): {
                        let message = <td>{this.props.t("driver")} <b>{events[i].driver_name}</b> {this.props.t("repliedToTheTeam")}: " <b><i>{events[i].message}</i></b> "</td>;
                        rows.push(
                            <tr key={"log7_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className={"fas fa-reply-all"}/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                {message}
                            </tr>
                        );
                        break;
                    }
                    // ORG_MESSAGE_TO_TEAM
                    case(8): {
                        rows.push(
                            <tr key={"log8_" + i} className={"App_black_text"}>
                                <td className={"text-center"}><i className="fas fa-user-tie"/></td>
                                <td className={"text-center"}>{Moment(events[i].timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                                <td style={{wordBreak: "break-all"}}>
                                    <Trans i18nKey={"orgMessageToTeam"}><strong>{this.props.t("orgMessageToTeam")}</strong></Trans>: " <b><i>{events[i].message}</i></b> "
                                </td>
                            </tr>
                        );
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        } else {
            rows = null;
        }

        this.setState({
            eventRows: rows,
        }, () => {
            this.initTable();
        });
    }

    render() {

        let isDisabled;
        if ((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) && this.props.carID) {
            isDisabled = false;
        } else {
            isDisabled = this.props.isOwnTeam !== 1;
        }

        return (
            <>
                <button
                    type={"button"}
                    data-tip={true}
                    data-for={"logWindow"}
                    className={"btn btn-primary btn-block button"}
                    onClick={this.handleShowModal}
                    disabled={isDisabled}
                >
                    <i className={"fas fa-clipboard-list App_buttonContainer_icons"}/>
                </button>
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "big-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_title"}>{this.props.t("actionHistory")}</b>
                            <b className={"App_title"} style={{float: "right"}}>{this.props.teamName}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"table-scroll-parent"} style={{height: "70vh"}}>
                            {this.state.showTable && this.state.eventRows && this.state.eventRows.length > 0 ? (
                                <table id={"logging"} className={"table table-hover table-condensed table-scroll-child"}>
                                    <thead>
                                    <tr>
                                        <th className={"App_header"} style={{color: "#000000", width: "5%"}}/>
                                        <th className={"App_header"} style={{color: "#000000", width: "20%"}}>{this.props.t("time").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000", textAlign: "left", width: "70%"}}>{this.props.t("description_full").toUpperCase()}</th>
                                        {this.props.isSessionChoice ? <th/> : null}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.eventRows}
                                    </tbody>
                                </table>
                            ) : (
                                <>
                                    {this.state.eventRows !== null ? (
                                        <div style={{width: "100%"}}>
                                            <div className={"loader"} style={{margin: "0 auto", marginTop: "15%"}}/>
                                        </div>
                                    ) : (
                                        <div className={"App_title"}>{this.props.t("noResults")}</div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <div style={{float: "left"}}>
                            <button className={"paginate btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold", marginRight: 3}}
                                    onClick={this.handleClickPager}
                                    id={"previous"}
                            >{this.props.t("previous")}</button>
                            <button className={"paginate btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    onClick={this.handleClickPager}
                                    id={"next"}
                            >{this.props.t("next")}</button>
                        </div>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_header button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(LoggingBox));